module.exports = __webpack_public_path__ + "img/place-holder-product-pic.b167f499.jpg";